import script from "./DynamicMovie.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicMovie.vue?vue&type=script&setup=true&lang=js"

import "./DynamicMovie.vue?vue&type=style&index=0&id=598eb3fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-598eb3fc"]])

export default __exports__